import { useEffect, useState } from "react";
import { api, euro, fmtDate, downloadReport } from "@/lib/api";
import { InternalLayout, PageHeader } from "@/components/InternalLayout";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { FileCsvIcon as FileCsv, FileXlsIcon as FileXls, FilePdfIcon as FilePdf } from "@phosphor-icons/react";

export default function Reports() {
  const [reports, setReports] = useState(null);

  useEffect(() => { api.get("/billing/reports").then(({ data }) => setReports(data)); }, []);

  return (
    <InternalLayout>
      <div className="p-8 lg:p-12">
        <PageHeader title="Report fatturazione" subtitle="Archivio dei report generati per la fatturazione esterna" />
        <Card className="rounded-sm border-border shadow-none">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Cliente</TableHead>
                <TableHead>Periodo</TableHead>
                <TableHead>Tipo</TableHead>
                <TableHead className="text-right">Totale</TableHead>
                <TableHead>Generato il</TableHead>
                <TableHead className="text-right">Download</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {reports?.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-muted-foreground py-10">Nessun report generato. Vai in Fatturazione per crearne uno.</TableCell></TableRow>}
              {reports?.map((r) => (
                <TableRow key={r.id} data-testid="report-row" className="hover:bg-secondary">
                  <TableCell className="font-medium">{r.cliente_nome}</TableCell>
                  <TableCell className="tabular-nums text-sm">{r.period_start} → {r.period_end}</TableCell>
                  <TableCell><Badge variant="outline" className="rounded-sm capitalize">{r.period_type}</Badge></TableCell>
                  <TableCell className="text-right tabular-nums font-medium">{euro(r.totale)}</TableCell>
                  <TableCell className="tabular-nums text-muted-foreground">{fmtDate(r.created_at)}</TableCell>
                  <TableCell className="text-right">
                    <div className="flex justify-end gap-1">
                      {r.files?.csv && <Button variant="ghost" size="icon" className="h-8 w-8" title="CSV" onClick={() => downloadReport(r.id, "csv", `report_${r.cliente_nome}`)}><FileCsv size={18} /></Button>}
                      {r.files?.xlsx && <Button variant="ghost" size="icon" className="h-8 w-8" title="Excel" onClick={() => downloadReport(r.id, "xlsx", `report_${r.cliente_nome}`)}><FileXls size={18} /></Button>}
                      {r.files?.pdf && <Button variant="ghost" size="icon" className="h-8 w-8" title="PDF" onClick={() => downloadReport(r.id, "pdf", `report_${r.cliente_nome}`)}><FilePdf size={18} /></Button>}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      </div>
    </InternalLayout>
  );
}
